import React, { useEffect, useState } from 'react';
import './index.css';
import clsx from 'classnames';
import QueueAnim from 'rc-queue-anim';

const BuildContent = () => {
  const [buildOpen, setBuildOpen] = useState('');
  const buildType = [
    {
      id: '1',
      type: '安全工器具实验室',
      value:
        '安全帽、脚扣、绝缘手套、绝缘鞋、接地线、验电器、绝缘服装、屏蔽服装、绝缘垫、绝缘操作杆等。',
    },
    {
      id: '2',
      type: '电力物资检测实验室',
      value: '变压器、互感器、开关柜、断路器、电缆保护管等。',
    },
    {
      id: '3',
      type: '电力施工机具实验室',
      value: '钢丝绳、吊装带、卸扣、千斤顶、滑车、手拉葫芦等。',
    },
    {
      id: '4',
      type: '高空作业防护器具实验室 ',
      value: '安全带、速差器、防坠器、安全网、检修平台等。',
    },
    {
      id: '5',
      type: '电线电缆及导地线实验室 ',
      value:
        '电力电缆、架空绝缘电缆、控制电缆、钢芯铝绞线、钢绞线、碳纤维导线等。',
    },
    {
      id: '6',
      type: '电力金具试验室',
      value: '耐张线夹、悬垂线夹、间隔棒、防震锤、母线金具',
    },
    {
      id: '7',
      type: '绝缘子实验室',
      value: '悬式盘形绝缘子、柱式绝缘子、复合绝缘子',
    },
    {
      id: '8',
      type: '紧固件及金属材料试验室',
      value: '热镀锌紧固件、大六角头紧固件、塔材、金属材料',
    },
    {
      id: '9',
      type: '绝缘斗臂车实验室',
      value: '绝缘斗臂车、高空作业车',
    },
    {
      id: '10',
      type: '充电桩实验室',
      value: '交流充电桩、直流充电桩',
    },
    {
      id: '11',
      type: '移动检测实验室',
      value: '安全工器具移动检测车、电力物资移动检测车、充电桩移动检测车',
    },
    {
      id: '12',
      type: '光伏实验室',
      value: '光伏组件、光伏电站',
    },
  ];

  const onBuildOpen = (id) => {
    if (window.innerWidth > 768) {
      setBuildOpen('');
    } else {
      setBuildOpen(buildOpen === id ? '' : id);
    }
  };

  // 监听窗口大小，防止样式错乱
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setBuildOpen('');
      }
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <QueueAnim className={clsx('construction-build')} type={['bottom', 'top']}>
      <div
        className={clsx('construction-build-title')}
        key='construction-build-title'
      >
        实验室建设
      </div>
      <div
        className={clsx('construction-build-list')}
        key='construction-build-list'
      >
        <div className={clsx('construction-build-list-title')}>
          <div className={clsx('construction-build-list-title-first-type')}>
            检测实验室类型
          </div>
          <div className={clsx('construction-build-list-title-first-value')}>
            检测对象
          </div>
        </div>
        <>
          {buildType.map((item, index) => (
            <div
              className={clsx('construction-build-list-title', {
                isOpen: buildOpen === item.id,
              })}
              key={index}
              type={['right', 'left']}
            >
              <div
                className={clsx('construction-build-list-title-type')}
                onClick={() => onBuildOpen(item.id)}
                key={`construction-build-list-title-type${index}`}
              >
                {item.type}
                {/* 向下箭头 */}
                <svg
                  width='16'
                  height='16'
                  viewBox='0 0 16 16'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                  className={clsx('build-svg')}
                >
                  <path d='M13.3333 8L8 13.3333L2.66667 8' stroke='#222' />
                </svg>
              </div>
              <div
                className={clsx('construction-build-list-title-value')}
                key={`construction-build-list-title-value${index}`}
              >
                {item.value}
              </div>
            </div>
          ))}
        </>
      </div>
    </QueueAnim>
  );
};

export default BuildContent;
